import { makeStyles } from 'tss-react/mui';

export const useDashboardStyles = makeStyles()((theme) => ({
  container: {
    margin: '0 auto',
    paddingBottom: theme.spacing(24),
    maxWidth: '594px',
    [theme.breakpoints.up('sm')]: {
      paddingBottom: theme.spacing(16),
    },
    [theme.breakpoints.up('md')]: {
      maxWidth: 'initial',
      paddingBottom: theme.spacing(8),
    }
  },
  dashboardTitle: {
    marginBottom: 0,
    color: theme.palette.darkSlate.main
  },
  darkSlate: {
    color: theme.palette.darkSlate.main
  },
  secondary: {
    color: theme.palette.secondary.main
  },
  grid: {
    display: 'grid',
    gap: theme.spacing(5),
    gridTemplateColumns: '1fr',
    [theme.breakpoints.up('sm')]: {
      gap: theme.spacing(9),
    },
    [theme.breakpoints.up('md')]: {
      gridTemplateColumns: '2fr minmax(282px, 1fr)',
      gap: theme.spacing(3),
    },
    [theme.breakpoints.up('lg')]: {
      gridTemplateColumns: '2fr minmax(320px, 1fr)',
      gap: theme.spacing(14),
    }
  },
  stack: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(5),
    [theme.breakpoints.up('sm')]: {
      gap: theme.spacing(9)
    }
  },
}));
